import { roundFloat } from '../../../../../../../utils/roundFloat'

export const calculateVat = (inclVatAmount: number, tax: number) =>
  roundFloat(inclVatAmount - inclVatAmount / (1 + tax))
